import React from "react";

export default function lazyImport<Component extends React.ComponentType<any>>(
  importPromise: () => Promise<{ default: Component }>,
  errCallback: () => void = errorCallback
) {
  const LazyComponent = React.lazy(() => {
    return componentLoader(importPromise, 3).catch((error) => {
      window.alert("Your Captyn has been updated to the latest version.");
      errCallback();
      throw error;
    });
  });

  // Expose the raw promise function so we can manually trigger chunk downloads
  return Object.assign(LazyComponent, { preload: importPromise });
}

const errorCallback = () => {
  window.location.reload();
};

function componentLoader<Module>(
  lazyComponent: () => Promise<Module>,
  attemptsLeft: number
): Promise<Module> {
  return new Promise<Module>((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (attemptsLeft === 1) {
            reject(error);
            return;
          }

          componentLoader(lazyComponent, attemptsLeft - 1).then(
            resolve,
            reject
          );
        }, 5000);
      });
  });
}
